// PageTransition.jsx
import { motion } from "framer-motion";

export default function PageTransition({ children }) {
    return (
        <motion.div
            initial={{ opacity: 0 }}          // aparece desde 0
            animate={{ opacity: 1 }}          // se vuelve visible
            exit={{ opacity: 0 }}             // desaparece
            transition={{ duration: 1.3 }}   // ajusta la velocidad
            style={{ height: "100%" }}
        >
            {children}
        </motion.div>
    );
}
